export enum ExamRecordStandardDetailsTab {
  Weight = 'weight',
  Measure = 'measure',
}

export interface IExamRecordStandard {
  rule_id: string
  rule_name: string
  available: boolean | null
  source: string
  template_type: string
}

export interface IExamRecordStandardDetails extends IExamRecordStandard {
  male_mapping: IExamRecordStandardDetailsMapping
  female_mapping: IExamRecordStandardDetailsMapping
}

export interface IExamRecordStandardDetailsMapping {
  support_grades: number[]
  body_exam_items: Array<{
    body_exam_item_name: string
    body_exam_item_type: string
    rules: Array<{
      weight: number
      mappings: {
        extra_mappings: Array<{
          grade: string
          original_value: number
          standard_score: number
        }>
        standard_mappings: Array<{
          grade: string
          original_value: number
          standard_score: number
        }>
      }
      grade_no: number
    }>
  }>
  exclude_visible_body_exam_item_types: string[]
}

// 处理逻辑, 按行分割， 数字开头的标题， *开头的重点, . 开头列表
export const ExamRecordStandardHint: { [key: string]: string } = {
  年级编号: `1、年级编号仅可以为以下数字
  小学1～6年级：11、12、13、14、15、16
  初中7～9年级：21、22、23
  高中1～3年级：31、32、33
  大一～大四：41、42、43、44`,
  班级编号: `1、班级编号仅可以为0～9数字
  正常班级编号最后两位数字为班号，
  例如：222102，为 22年的初一02班。初一的年级编号为21。
  如班级名称和班级编号都无法识别班号，则会导入错误，请手动修改`,
  班级名称: `1、班级名称包含特殊字母
  班级名称仅支持数字0～9+中文组合。
  例如：一年级309班，为09号班。系统会识别【班】前的数字后两位，作为班号。
  如班级名称和班级编号都无法识别班号，则会导入错误，请手动修改`,
  学籍号: `1、学籍号包含特殊字符
  学籍号仅支持数字0～9+英文字母组合。
  2、学籍号重复
  本校内学籍号唯一，表格中不可出现重复学籍号。
  学籍号正常为G或者L+身份证号，全国唯一。
  *本平台承诺，该信息仅本校可查看，本平台不会利用或者泄漏学籍号信息。`,
  姓名: `1、姓名号包含特殊字符
  仅支持中文、英文、以及符号·。`,
  性别: `1、性别包含特殊字符
  录入男、女，1=男、2=女。`,
  身高: `1、身高包含特殊字符
  .单位：cm
  .三位数值为厘米，154为厘米
  .数值范围：50～300`,
  体重: `1、体重包含特殊字符
  .单位为kg
  .数值范围：10-300`,
  肺活量: `1、肺活量包含特殊字符
  .单位：ml
  .数值范围：500～9999`,
  坐位体前屈: `1、坐位体前屈包含特殊字符
  .单位：厘米
  .数值范围：-30～40
  .允许1位小数录入`,
  一分钟跳绳: `1、一分钟跳绳号包含特殊字符
  .单位：个
  .数值范围 ：0-300
  .整数`,
  仰卧起坐: `1、仰卧起坐包含特殊字符
  .数值范围 0～99
  .整数`,
  '50米跑': `1、50米跑包含特殊字符
  .数值范围：5.0～20.0
  .1位小数
  .单位：秒
  .秒的符号为【.】或者【″】`,
  '50米*8': `1、50米*8别包含特殊字符
  .单位：秒
  .数值范围 >0
  .格式 3′45″ (″(秒号)可省略) 或者3′45″ (″(双引号)可省略 )`,
  '800米': `1、800米包含特殊字符
  .单位：秒
  .数值范围 >0
  .格式 3′45″ (″(秒号)可省略) 或者3′45″ (″(双引号)可省略 )`,
  '1000米': `1、1000米包含特殊字符
  .单位：秒
  .数值范围 >0
  .格式 3′45″ (″(秒号)可省略) 或者3′45″ (″(双引号)可省略 )`,
  立定跳远: `1、立定跳远包含特殊字符
  .单位：厘米
  .数值范围：50～400cm`,
  引体向上: `1、引体向上包含特殊字符
  .数值范围 0～99
  .整数`,
}

export function buildExamRecordStandardHintLines(colName: string) {
  const txt = ExamRecordStandardHint[colName]
  if (!txt) {
    return null
  }
  const reasonLines: { cssClass: string; content: string }[] = [
    {
      cssClass: 'title',
      content: `${colName}错误可能为以下原因`,
    },
  ]
  const lines = txt.split('\n')
  for (let line of lines) {
    line = line.trim()
    if (line.startsWith('.')) {
      reasonLines.push({ cssClass: 'list', content: line.slice(1) })
    } else if (line.startsWith('*')) {
      reasonLines.push({ cssClass: 'strong', content: line.slice(1) })
    } else if (/\d、.*/.test(line)) {
      reasonLines.push({ cssClass: 'item', content: line })
    } else {
      reasonLines.push({ cssClass: '', content: line })
    }
  }
  return reasonLines
}
